import React from 'react';
import './App.css';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { useCookies } from "react-cookie";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CookieConsentManager from './components/CookieConsentManager';
import { useEffect } from 'react';
//pages
import Preloader from './components/Preloader';
import Home from './components/Pages/Home';
import WhoWeAre from './components/Pages/WhoWeAre';
import WhatWeDo from './components/Pages/WhatWeDo';
import Products from './components/Pages/Products';
import Contact from './components/Pages/Contact';
import TSO from './components/Pages/TSO';
import Companies from './components/Pages/Business';
import Households from './components/Pages/Households';
import Partners from './components/Pages/Partners';
import RCI from './components/Pages/RCI';
import EEC from './components/Pages/EEC';
import BBSS from './components/Pages/BBSS';
import LegalNotice from './components/Pages/LegalNotice';
import Impressum from './components/Pages/Impressum';
import Terms from './components/Pages/Terms';
import PrivacyPolicy from './components/Pages/PrivacyPolicy';
import ComFlex from './components/Pages/ComFlex';
import ComSolar from './components/Pages/ComSolar';
import ComSupply from './components/Pages/ComSupply';
import JoinUs from './components/Pages/JoinUs';
import ElSupply from './components/Pages/ElSupply';
// import Connection from './components/Pages/Connection';
import ScrollToTop from "./ScrollToTop";
import Documents from './components/Pages/Documents';
import { Helmet } from 'react-helmet';
import JobDescription from './components/Pages/JobDescription';
import SupplyHouseholds from './components/Pages/SupplyHouseholds';
import SupplyCompanies from './components/Pages/SupplyCompanies';
import SupportPortugal from './components/Pages/SupportPortugal';
import ElSelfsuf from './components/Pages/ElSelfsuf';
import Blog from './components/Pages/Blog/Blog';
import Post from './components/Pages/Blog/Post';
import EnvSocial from './components/Pages/EnvSocial';

const App = () => {
  const { t } = useTranslation();
  /*const [cookies, setCookie] = useCookies(["introvideo"]);

  if(!cookies.videointro) {
    if (isMobile) {
      var HomeRoute = <Home />;
    } else {
      var HomeRoute = <Preloader />;
    }
  } else {
    var HomeRoute = <Home />;
  }*/
  var HomeRoute = <Home />;
  var lang = i18n.language;

  //manjka še: _at
  const gtmMap = {
    '_hr': 'GTM-NDLRGSPT',
    '_si': 'GTM-KR5WP6MZ',
    '_de': 'GTM-PZ4ZSMQN',
    '_at': 'GTM-P296PSL4',
    '_en': 'GTM-PP4SFHXK',
    '_pt': 'GTM-KSXTRFNT',
    '_pl': 'GTM-KFBLXWL3',
    '_es': 'GTM-MH8GRSQ9',
  };
  const activeKey = Object.keys(gtmMap).find(key => lang.includes(key));
  const gtmId = gtmMap[activeKey];

  useEffect(() => {
    // 1. CLEAR PREVIOUS SCRIPTS
    const gtmScripts = document.querySelectorAll(
      'script[src*="googletagmanager.com/gtm.js"], script[src*="googletagmanager.com/gtag/js"]'
    );
    gtmScripts.forEach(script => script.remove());

    // 2. RESET THE DATALAYER
    window.dataLayer = [];

    // 3. CREATE NEW GTM SCRIPT
    const script = document.createElement('script');
    script.async = true;
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');`;

    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    noscript.id = "gtm-noscript";
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

    document.body.prepend(noscript);

    return () => {
      script.remove();
      noscript.remove();
    };
  }, [gtmId]); // This effect re-runs every time gtmId changes
  return (
    <>


      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          {/* <Route index element={HomeRoute} /> */}
          <Route index element={<Home />} />
          <Route exact path={t('url.home')} element={<Home />} />
          <Route exact path={t('url.whoweare')} element={<WhoWeAre />} />
          <Route exact path={t('url.whatwedo')} element={<WhatWeDo />} />
          <Route exact path={t('url.products')} element={<Products />} />
          <Route exact path={t('url.contact')} element={<Contact />} />
          <Route exact path={t('url.tso')} element={<TSO />} />
          <Route exact path={t('url.podjetja')} element={<Companies />} />
          <Route exact path={t('url.gospodinjstva')} element={<Households />} />
          <Route exact path={t('url.elsupply')} element={<ElSupply />} />
          <Route exact path={t('url.supplyHouseholds')} element={<SupplyHouseholds />} />
          <Route exact path={t('url.supplyCompanies')} element={<SupplyCompanies />} />
          <Route exact path={t('url.novadobasamooskrbe')} element={<ElSelfsuf />} />
          <Route exact path={t('url.novadobasamooskrbe') + '#soo'} element={<ElSelfsuf />} />
          <Route exact path={t('url.novadobasamooskrbe') + '#hee'} element={<ElSelfsuf />} />
          <Route exact path={t('url.novadobasamooskrbe') + '#nds'} element={<ElSelfsuf />} />

          <Route exact path={t('url.elsupply') + '#functions'} element={<ElSupply />} />
          <Route exact path={t('url.elsupply') + '#virtual'} element={<ElSupply />} />
          <Route exact path={t('url.gospodinjstva') + '#doee'} element={<Households />} />
          <Route exact path={t('url.gospodinjstva') + '#bess'} element={<Households />} />
          <Route exact path={t('url.gospodinjstva') + '#sgconnect'} element={<Households />} />

          <Route exact path={t('url.poslovnipartnerji')} element={<Partners />} />

          <Route exact path={t('url.com-flex')} element={<ComFlex />} />
          <Route exact path={t('url.com-solar')} element={<ComSolar />} />
          <Route exact path={t('url.com-supply')} element={<ComSupply />} />

          <Route exact path={t('url.eec')} element={<EEC />} />
          <Route exact path={t('url.rci')} element={<RCI />} />
          <Route exact path={t('url.bbss')} element={<BBSS />} />
          <Route exact path={t('url.legalnotice')} element={<LegalNotice />} />
          <Route exact path={t('url.impressum')} element={<Impressum />} />
          <Route exact path={t('url.privacypolicy')} element={<PrivacyPolicy />} />
          <Route exact path={t('url.terms')} element={<Terms />} />
          <Route exact path={t('url.documents')} element={<Documents />} />
          <Route exact path={t('url.joinourteam')} element={<JoinUs />} />
          <Route exact path={t('url.blog')} element={<Blog />} />
          <Route path={`${t('url.post')}/:slugAndId`} element={<Post />} />
          <Route exact path={t('url.job-description') + '/:index'} element={<JobDescription />} />

          <Route exact path={t('url.environment_social')} element={<EnvSocial />} />
          {/* <Route exact path={t('url.ngenconnection')} element={<Connection />} /> */}

          <Route exact path={('url.SupportPortugal')} element={<SupportPortugal />} />

          <Route path="*" element={<Navigate to={'/' + lang} replace />} />

        </Routes>

        <CookieConsentManager />

        <Footer />
      </BrowserRouter>
    </>

  );
}

export default App;
